const VueDraggableNext = defineAsyncComponent(() => import('vue-draggable-next').then(m => m.VueDraggableNext))

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('draggable', VueDraggableNext)
})